import CreateBoardContainer from "../containers/CreateBoardContainer";

const CreateBoardPage = () => {
  return (
    <CreateBoardContainer />
  );
};

export default CreateBoardPage;
